module.exports = __webpack_public_path__ + "img/商城广东联通流量卡.2d469230.png";